export class ImplementStatusModalData {
    public implementId: number;
    public jobsiteId: number;
    public status: number;
    public repairerId: number;
    public workshopId: number;
    public comment: string;
    public date: Date;
}